module.exports = __webpack_public_path__ + "media/components/country-flag/static/cr-6567f50f336a5bae3abcdbd9f0b974c9.svg";